import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {CreateDatingProfilePresenter} from "./createDatingProfilePresenter";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class CreateDatingProfileView extends ViewBase implements IView {

    public _presenter: CreateDatingProfilePresenter;

    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer) {
        super(viewName, router, dependencyContainer);
    }

    public get age() {
        return this.getValueById('age');
    }

    public set age(value) {
        this.setValueById('age', value);
    }

    public get aboutMe() {
        return this.getValueById('about-me')
    }

    public set aboutMe(value) {
        this.setValueById('about-me', value);
    }

    public setPresenter(presenter: CreateDatingProfilePresenter) {
        this._presenter = presenter;
    }

    render(): void {
    }


}